import { ref, computed } from "vue"
//import { mergeGlobalConfig } from 'vuestic-ui'

export const THEME_NAMES = {
  LIGHT: 'LIGHT',
  SEMI_DARK: 'SEMI_DARK',
  FINDEX: 'FINDEX',
  FINDEX2: 'FINDEX2'
}

export const COLOR_THEMES = [
  {
    name: THEME_NAMES.LIGHT,
    colors: {
      primary: '#154ec1',
      secondary: '#767c88',
      background: '#f6f7f6',
      success: '#3d9209',
      info: '#2c82e0',
      danger: '#e42222',
      warning: '#ffd43a',
      white: '#ffffff',
      dark: '#262824',
      gray: '#767c88'
    },
    components: {
      VaNavbar: {
        color: 'white',
        textColor: 'dark'
      },
      VaSidebar: {
        color: 'white',
        textColor: 'dark'
      },
      VaCard: {
        color: 'white'
      },
      VaCardContent: {
        textColor: 'white'
      },
      VaCardTitle: {
        textColor: 'dark'
      }
    }
  },
  {
    name: THEME_NAMES.SEMI_DARK,
    colors: {
      primary: '#ee4822',
      secondary: '#f2f5f6',
      background: '#bac3c7',
      success: '#6ac288',
      info: '#0091D0',
      danger: '#ee4822',
      warning: '#ff7f11',
      white: '#ffffff',
      dark: '#2e3c49',
      gray: '#949396'
    },
    components: {
      VaNavbar: {
        color: 'white',
        textColor: 'dark'
      },
      VaSidebar: {
        color: 'white',
        textColor: 'dark'
      },
      VaCard: {
        color: 'white'
      },
      VaCardContent: {
        textColor: 'dark'
      },
      VaCardTitle: {
        textColor: 'dark'
      }
    }
  },
  {
    name: THEME_NAMES.FINDEX,
    colors: {
      primary: '#ee4822', //#d43f27 as per website //#ee4822 as per color shared
      secondary: '#A8AEBA',
      success: '#3d9209',
      info: '#2c82e0',
      danger: '#e42222',
      warning: '#ff7f11',
      background: '#2E3349',
      table: '#bac3c7',
      white: '#ffffff',
      dark: '#262824',
      gray: '#767c88',
      orange: '#d43d27', //Findex Orange
      purple: '#516cb3', //Findex Purple
      blue: '#0eacbd',   //Findex Blue
      green: '#8dc63f'   //Findex Green
    },
    components: {
      VaNavbar: {
        color: '#2E3349',
        textColor: 'dark'
      },
      VaSidebar: {
        color: '#2E3349',
        textColor: 'white'
      },
      VaInput: {
        color: '#fff',
        textColor: 'white'
      },
      VaCard: {
        color: '#363649', //'dark'
        textColor: 'white',
        border: "10px solid white"
      },
      VaCardContent: {
        textColor: 'white'
      },
      VaCardTitle: {
        textColor: 'white'
      }
    }
  },
  {
    name: THEME_NAMES.FINDEX2,
    colors: {
      primary: '#D43D27',
      secondary: '#2E3C49',
      background: '#252A30',
      success: '#8DC63F',
      info: '#0EACBD',
      danger: '#EE4823',
      warning: '#BAC3C7',
      white: '#FFFFFF',
      dark: '#252A30', //'#1B1F22',
      gray: '#BAC3C7'
    },
    components: {
      VaNavbar: {
        color: '#1B1F22',
        textColor: 'white'
      },
      VaSidebar: {
        color: '#1B1F22',
        textColor: 'white'
      },
      VaCard: {
        color: '#252A30',
        textColor: 'white'
      },
      VaCardContent: {
        textColor: 'white'
      },
      VaCardTitle: {
        textColor: 'white'
      }
    }
  }
]

export const useTheme = () => {
  const themeNameRef = ref(THEME_NAMES.FINDEX)

  const setTheme = (themeName: keyof typeof THEME_NAMES) => {
    themeNameRef.value = themeName
    const theme = COLOR_THEMES.find((theme) => theme.name === themeName)

    if (!theme) { throw new Error('Theme not found') }

   // mergeGlobalConfig({ colors: theme.colors as any, components: theme.components })
  }

  const theme = computed(() => COLOR_THEMES.find((theme) => theme.name === themeNameRef.value))

  return { setTheme, themeName: themeNameRef, theme }
}